// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConversationsService } from '@app/core/services/conversations/conversations.service';
import { Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { defaultUserImage } from '@app/core/helpers/constants';
import { PrivateChatService } from '@app/core/services/private-chat/private-chat.service';
import { BaseApiResponse, IChatUser } from '@app/core/models/core-models';
import { debounce } from 'lodash';

const LIST_SCROLL_END_OFFSET = 25;

@Component({
  selector: 'app-new-conversation-search',
  templateUrl: './new-conversation-search.component.html',
  styleUrls: ['./new-conversation-search.component.scss']
})
export class NewConversationSearchComponent implements OnInit {
  @Input() fullChatView = false;
  @Input() width?: number;
  @Output() emitClose: EventEmitter<boolean> = new EventEmitter();
  public searchInput = '';
  public usersList$?: Observable<BaseApiResponse<{ users?: IChatUser[] }>>;
  public search$ = new Subject<string>();
  public searchFocus = false;
  public scrolledToBottom = false;
  public readonly defaultImage = defaultUserImage;

  private unsubscribe$ = new Subject<void>();
  private debouncedListScrollListener = debounce((event: Event) => {
    this.scrolledToBottom = (event.target as HTMLElement).scrollTop >= (event.target as HTMLElement).offsetHeight - LIST_SCROLL_END_OFFSET;
  }, 100);

  constructor(private conversationsService: ConversationsService, private privateChat: PrivateChatService) {}

  ngOnInit(): void {
    this.search$.pipe(debounceTime(300), takeUntil(this.unsubscribe$)).subscribe(() => {
      this.searchData();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public closePopup(): void {
    this.emitClose.emit();
  }

  public searchFilter(): void {
    if (this.searchInput.trim().length >= 3) {
      this.search$.next('');
    }
  }

  public goToConversation(user: IChatUser): void {
    if (user) {
      if (this.fullChatView) {
        this.privateChat.fullviewActiveChatObser.next(user);
      } else {
        this.privateChat.togglePrivateChat({ status: true, userType: 'user' });
        this.privateChat.sentCurrentChat(user);
      }
    }
  }

  public handleResultsScroll(event: Event): void {
    this.debouncedListScrollListener(event);
  }

  private searchData(): void {
    this.usersList$ = this.conversationsService.searchConversations('username', this.searchInput.trim());
  }
}
